const api_local = 'http://localhost:8002';
const api_prod = 'https://api.pdvemfoco.com.br';
const api = api_prod;

export { api };